import type { ReactNode } from 'react';

export const symbol_mode_off_on: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458.5-486.5Q450-495 450-508v-346q0-13 8.5-21.5T480-884q13 0 21.5 8.5T510-854v346q0 13-8.5 21.5T480-478q-13 0-21.5-8.5Zm-119 340q-65.5-28.5-114-77t-77-114Q120-403 120-478q0-64 22.5-123.5T207-709q9-10 22-10.5t23 9.5q8 8 6.5 20.5T249-667q-34 39-51.5 88T180-478q0 125 87.5 212.5T480-178q125 0 212.5-87.5T780-478q0-53-17.5-101.5T711-668q-8-10-9-22t7-20q10-10 24-9t23 12q42 48 63 107t21 122q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-118q-75 0-140.5-28.5Z"
		/>
	</svg>
);
